export default {"src":"/_next/static/media/mark.5ecc275b.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};